import { CasBaseDialog, CasButton, CasDeleteButton } from 'src/compass/shared/components';
import { ICasBaseDialog } from './CasBaseDialog';

export type CasDialogProps = ICasBaseDialog & {
  id?: string;
  canDelete: boolean;
  deleteLabelSuffix: string;
  saveButtonLabel: string;
  // Greys the save button out, for a record the user may look at but not change.
  saveDisabled?: boolean;
  onConfirmDelete: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  onSave: VoidFunction;
};

export default function CasDialog({
  onClose,
  id,
  canDelete = true,
  deleteLabelSuffix,
  saveButtonLabel,
  saveDisabled = false,
  children,
  onConfirmDelete,
  onSave,
  ...other
}: CasDialogProps) {
  return (
    <CasBaseDialog
      {...other}
      onClose={onClose}
      actions={
        <>
          {canDelete && id && (
            <CasDeleteButton deleteLabelSuffix={deleteLabelSuffix} onClick={onConfirmDelete} />
          )}
          <CasButton color="secondary" variant="outlined" onClick={onClose}>
            Cancel
          </CasButton>
          <CasButton onClick={onSave} disabled={saveDisabled}>
            {saveButtonLabel}
          </CasButton>
        </>
      }
    >
      {children}
    </CasBaseDialog>
  );
}
